/*
  The initial state of the application.
*/
const RTCInitialState = {
  timeOffset: window?.SERVER_DATA?.serverTime - Date.now() ?? 0,
}

const RTCReducer = (state, action) => {
  const change = { ...state }
  switch (action.type) {
    default: {
      console.error(`ERROR: Unhandled action type: ${action.type}`) // eslint-disable-line
    }
  }

  return { ...change }
}

export { RTCInitialState, RTCReducer }
